import React from "react"
import Head from "next/head"
import { OG } from "."

interface Props {
  date: string
  duration?: string
  url: string
}

// -----------------------------
// Opengraph Docs — https://ogp.me/
// Facebook Opengraph for Video: https://developers.facebook.com/docs/sharing/webmasters#video

export const OGVideo = ({ url, duration, date }: Props) => {
  const embedURL = `${url}`
  const opengraph = [
    // <meta property="og:video" content="VIDEO_EMBED_URL" />
    { key: OG.VideoURL, property: OG.VideoURL, content: embedURL },
    // <meta property="og:video:secure_url" content="VIDEO_EMBED_URL" />
    { key: OG.VideoSecureURL, property: OG.VideoSecureURL, content: embedURL },
    // <meta property="og:video:type" content="video/mp4" />
    { key: OG.VideoType, property: OG.VideoType, content: "video/mp4" },
    // <meta property="og:video:width" content="1280" />
    { key: OG.VideoWidth, property: OG.VideoWidth, content: "1280" },
    // <meta property="og:video:width" content="1280" />
    { key: OG.VideoHeight, property: OG.VideoHeight, content: "1280" },
  ]

  // <meta property="og:video:release_date" content="2022-01-23" />
  date && opengraph.push({ key: OG.VideoReleaseDate, property: OG.VideoReleaseDate, content: date })
  // <meta property="og:video:duration" content="46" /> -- in seconds
  duration && opengraph.push({ key: OG.VideoDuration, property: OG.VideoDuration, content: duration })

  const allTags = opengraph.map((item) => (
    <meta data-testid={item.key} key={item.key} property={item.property} content={item.content} />
  ))

  return <Head>{allTags}</Head>
}
